<template>
  <div class="about">
    <button class="about__resume" @click="$emit('openModal', 'resume_book')"
      aria-label="Button to open resume book"></button>
    <button class="about__folder" @click="$emit('openModal', 'perpetual_pen')"
      aria-label="Button to open hidden folder"></button>
  </div>
</template>

<script>
export default { name: 'About' };
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.about{
  @include abs(0, 0, 1920px, 1920px);
  transform-origin: 0 0;
  background: url(../assets/bgd/about.jpg) center no-repeat;
  background-size: cover;

  &__resume{
    @include abs(775px, 755px, 230px, 170px);
    @media (max-width: 768px) { @include abs(705px, 705px, 300px, 240px); }
    @include mouseoverButton(resume-mo);
    background: url(../assets/button/resume.png) no-repeat center center;
    background-size: contain;
    &:active{
      @include abs(775px, 702px, 230px, 290px);
      @media (max-width: 768px) { @include abs(705px, 630px, 300px, 410px); }
      background: url(../assets/button/resume-oc.png) no-repeat center center;
      background-size: contain;
    }
  }

  &__folder{
    @include abs(936px, 959px, 85px, 360px);
    @include mouseoverButton(folder-mo);
    background: url(../assets/button/folder.png) no-repeat center center;
    background-size: contain;
    &:hover, &:focus{ @include abs(936px, 959px, 112px, 360px); }
    &:active{
      @include abs(936px, 936px, 325px, 383px);
      background: url(../assets/button/folder-oc.png) no-repeat center center;
      background-size: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue